module.exports = __webpack_public_path__ + "img/LogoWhite.03cf60cd.png";